import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import SourceBranches from 'components/modal/room-available-components/source-branches';

interface SelectMultiBranchesModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
  selectedSourceBranches: number[] | undefined;
  setSelectedSourceBranches: (branches: number[] | undefined) => void;
  title?: string;
  placeholder?: string;
}

const SelectMultiBranchesModal: React.FC<SelectMultiBranchesModalProps> = ({
  open,
  onCancel,
  onOk,
  selectedSourceBranches,
  setSelectedSourceBranches,
  title,
  placeholder
}) => {
  const { t } = useTranslation();

  const defaultTitle =
    title || t('managePage.consolidateRevenueReportPage.actions.sourceRevenueBranches');
  const defaultPlaceholder =
    placeholder || t('managePage.consolidateRevenueReportPage.placeholders.selectBranches');

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      title={defaultTitle}
      destroyOnClose
      width={500}
      okText={t('common.actions.apply')}
      okButtonProps={{ className: 'ant-btn-secondary btn-submit' }}
      cancelText={t('common.actions.cancel')}
    >
      <div style={{ padding: '16px 0' }}>
        <SourceBranches
          value={selectedSourceBranches}
          onChange={setSelectedSourceBranches}
          placeholder={defaultPlaceholder}
        />
      </div>
    </Modal>
  );
};

export default SelectMultiBranchesModal;
